import { localizeNumber } from "../../../../helpers";
import ibsStore from "../../../Stores/IbsSurveyStore"
import store from "../../../Stores/SurveyStore"
import { NumberFormat } from "../../../../Enums/constants";
import { columnCalculation, columnCalculationDataObj } from "../../../../Helpers/TableCalculationHelper";
import { formatNumber } from "../../../../Helpers/General/FormatHelper";

export function createAssetAllocationData(props, referenceToTable, listOfHeaderRows, dataObj) {
    var rowCount = -1;
    listOfHeaderRows = [] //keep track of what rows are headers

    //structure for category sections
    if (ibsStore.allTableResponses[props.tableName]) {
        var unique = [...new Set(ibsStore.allTableResponses[props.tableName].map(item => item.MainCategoryName))]; // [ 'A', 'B']
    }
    else return


    unique.forEach(element => {
        var result = [];
        var categoryTypeRow = { MainCategoryName: element, SubCategoryName: null, InternalPassiveMillions: null, ExternalPassiveMillions: null, Total: null, RowID: null, __children: null }

        if (store.questionMode) {
            categoryTypeRow = { MainCategoryName: "MainCategoryName", SubCategoryName: null, InternalPassiveMillions: null, ExternalPassiveMillions: null, Total: null, __children: null }

        }
        result = ibsStore.allTableResponses[props.tableName].filter(row => row.MainCategoryName == element);
        //    result = result.sort(sortFunctionByID("AssetClassName"))
        rowCount = rowCount + 1


        //take result and iterate to add to children data rows
        var child = {}
        result.forEach(row => {
            rowCount = rowCount + 1
            if (!store.questionMode) {
                child =
                {
                    __MainCategoryName: element,
                    MainCategoryName: "",
                    SubCategoryName: row.SubCategoryName,
                    InternalPassiveMillions: localizeNumber(row.InternalPassiveMillions),
                    ExternalPassiveMillions: localizeNumber(row.ExternalPassiveMillions),
                    Total: localizeNumber(row.InternalPassiveMillions + row.ExternalPassiveMillions),
                    RowID: row.RowID,

                }
            }

            dataObj.push(child)

            referenceToTable.push(child)

        })

        let totalRow = {
            MainCategoryName: "",
            SubCategoryName: "Total",
            InternalPassiveMillions: formatNumber(NumberFormat.MONEYMILLION, columnCalculation("InternalPassiveMillions", true, props)),
            ExternalPassiveMillions: formatNumber(NumberFormat.MONEYMILLION, columnCalculation("ExternalPassiveMillions", true, props)),
            Total: formatNumber(NumberFormat.MONEYMILLION, columnCalculationDataObj("Total", dataObj)),
            RowID: "",
            __children: null
        }

        dataObj.push(totalRow)
        referenceToTable.push(totalRow)
    });
    listOfHeaderRows.push(4)
    return [dataObj, listOfHeaderRows];
}

export function handleAssetAllocation(props, referenceToTable, listOfHeaderRows, dataObj) {
    let assetAllocReturnObj = createAssetAllocationData(props, referenceToTable, listOfHeaderRows, dataObj);
    let data = assetAllocReturnObj[0]
    let headers = assetAllocReturnObj[1]
    return [data, referenceToTable, headers]


}